import axios from 'axios';
import { openReceiptWindow } from '../utils/receiptUtils';

const API_URL = '/api/receipts';

const ReceiptService = {
  async generateAssignmentReceipt(assignmentIds) {
    const response = await axios.post(`${API_URL}/assignments`, { entityIds: assignmentIds });
    await openReceiptWindow(response.data);
    return response.data;
  },

  async generateTransferReceipt(assignmentId) {
    const response = await axios.post(`${API_URL}/transfers/${assignmentId}`);
    await openReceiptWindow(response.data);
    return response.data;
  },

  async generatePurchaseReceipt(purchaseEntryId) {
    const response = await axios.post(`${API_URL}/purchases/${purchaseEntryId}`);
    await openReceiptWindow(response.data);
    return response.data;
  },

  async generateRepairCreationReceipt(repairIds) {
    const response = await axios.post(`${API_URL}/repairs/creation`, { entityIds: repairIds });
    await openReceiptWindow(response.data);
    return response.data;
  },

  async generateRepairCompletionReceipt(repairId) {
    const response = await axios.post(`${API_URL}/repairs/completion/${repairId}`);
    await openReceiptWindow(response.data);
    return response.data;
  },

  async generateRepairCompletionReceiptBatch(repairIds) {
    const response = await axios.post(`${API_URL}/repairs/completion`, { entityIds: repairIds });
    await openReceiptWindow(response.data);
    return response.data;
  },

  async verifyReceipt(receiptNumber) {
    const response = await axios.get(`${API_URL}/verify/${encodeURIComponent(receiptNumber)}`);
    return response.data;
  }
};

export default ReceiptService;
